import React from 'react';
import { LayoutProps } from "./Layout.types";
import { Header } from "./header";
import { Footer } from "./footer";
import { useParams } from 'react-router-dom';

export function Layout({children, fullWidth = false}: LayoutProps) {
  const params = useParams();
    return (
        <div className='water-taxi'>
          <div className='container-fluid'>
            <Header />
          </div>
          <div className={ fullWidth ? 'container-fluid py-5' : 'container py-5'}>
            {children}
          </div>
          <div className='container-fluid'>
            <Footer />
          </div>
        </div>
    )
}
